import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageTitle } from "@/contexts/page-title-context";
function AdminApplicationsLayout({ children }: { children: React.ReactNode }) {
  const { t: tAdminApplications } = useTranslation("admin.applications");

  return (
    <>
      <PageTitle>{tAdminApplications("title")}</PageTitle>
      {children}
    </>
  );
}

export const Route = createFileRoute("/_app/admin/applications")({
  component: function LayoutRoute() {
    return (
      <AdminApplicationsLayout>
        <Outlet />
      </AdminApplicationsLayout>
    );
  },
});
